import { Component, OnInit } from "@angular/core";
import { UserManager } from "../../Services/UserManager/user-manager";
import { Profile } from "../../Models/profile.interface";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";

@Component({
  selector: "app-finished",
  templateUrl: "./finished.component.html",
  styleUrls: ["./finished.component.css"],
})
export class FinishedComponent implements OnInit {
  profileSubject: Observable<Profile>;
  profileSubscription: Subscription;
  profile = {} as Profile;
  firstname;
  lastname;
  config;
  // blankCertificate ='/Users/jfluence/Documents/IIWProjects/studiesv2/src/assets/Images/certificate.png'
  blankCertificate = "/assets/Images/cover1.png";

  constructor(private um: UserManager, private ls: LanguageSwitchService) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {
    this.profileSubject = this.um.getProfileSubject();
    this.profileSubscription = this.profileSubject.subscribe((profile) => {
      if (profile) {
        if (profile.firstname) {
          this.firstname = profile.firstname;
        }
        if (profile.lastname) {
          this.lastname = profile.lastname;
        }
      }
    });
  }
  gotoMyLessons() {
    this.um.gotoMyLessons();
  }
  gotoContactUs() {
    this.um.gotoContactUs();
  }
}
